// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: structs/structs/vault_vesting.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { BaseAccount } from "../../cosmos/auth/v1beta1/auth";
import { Coin } from "../../cosmos/base/v1beta1/coin";
import { Period } from "../../cosmos/vesting/v1beta1/vesting";

export const protobufPackage = "structs.structs";

export interface VaultVestingAccount {
  baseAccount: BaseAccount | undefined;
  ownerId: string;
  schedules: VaultVestingSchedule[];
  liquidDelegated: Coin[];
}

export interface VaultVestingSchedule {
  sourceAddress: Uint8Array;
  kind: number;
  startTime: string;
  endTime: string;
  originalVesting: Coin[];
  delegatedFree: Coin[];
  delegatedVesting: Coin[];
  periods: Period[];
}

function createBaseVaultVestingAccount(): VaultVestingAccount {
  return { baseAccount: undefined, ownerId: "", schedules: [], liquidDelegated: [] };
}

export const VaultVestingAccount: MessageFns<VaultVestingAccount> = {
  encode(message: VaultVestingAccount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseAccount !== undefined) {
      BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).join();
    }
    if (message.ownerId !== "") {
      writer.uint32(18).string(message.ownerId);
    }
    for (const v of message.schedules) {
      VaultVestingSchedule.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.liquidDelegated) {
      Coin.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VaultVestingAccount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVaultVestingAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseAccount = BaseAccount.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ownerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.schedules.push(VaultVestingSchedule.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.liquidDelegated.push(Coin.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VaultVestingAccount {
    return {
      baseAccount: isSet(object.baseAccount) ? BaseAccount.fromJSON(object.baseAccount) : undefined,
      ownerId: isSet(object.ownerId) ? globalThis.String(object.ownerId) : "",
      schedules: globalThis.Array.isArray(object?.schedules)
        ? object.schedules.map((e: any) => VaultVestingSchedule.fromJSON(e))
        : [],
      liquidDelegated: globalThis.Array.isArray(object?.liquidDelegated)
        ? object.liquidDelegated.map((e: any) => Coin.fromJSON(e))
        : [],
    };
  },

  toJSON(message: VaultVestingAccount): unknown {
    const obj: any = {};
    if (message.baseAccount !== undefined) {
      obj.baseAccount = BaseAccount.toJSON(message.baseAccount);
    }
    if (message.ownerId !== "") {
      obj.ownerId = message.ownerId;
    }
    if (message.schedules?.length) {
      obj.schedules = message.schedules.map((e) => VaultVestingSchedule.toJSON(e));
    }
    if (message.liquidDelegated?.length) {
      obj.liquidDelegated = message.liquidDelegated.map((e) => Coin.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VaultVestingAccount>, I>>(base?: I): VaultVestingAccount {
    return VaultVestingAccount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VaultVestingAccount>, I>>(object: I): VaultVestingAccount {
    const message = createBaseVaultVestingAccount();
    message.baseAccount = (object.baseAccount !== undefined && object.baseAccount !== null)
      ? BaseAccount.fromPartial(object.baseAccount)
      : undefined;
    message.ownerId = object.ownerId ?? "";
    message.schedules = object.schedules?.map((e) => VaultVestingSchedule.fromPartial(e)) || [];
    message.liquidDelegated = object.liquidDelegated?.map((e) => Coin.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVaultVestingSchedule(): VaultVestingSchedule {
  return {
    sourceAddress: new Uint8Array(0),
    kind: 0,
    startTime: "0",
    endTime: "0",
    originalVesting: [],
    delegatedFree: [],
    delegatedVesting: [],
    periods: [],
  };
}

export const VaultVestingSchedule: MessageFns<VaultVestingSchedule> = {
  encode(message: VaultVestingSchedule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sourceAddress.length !== 0) {
      writer.uint32(10).bytes(message.sourceAddress);
    }
    if (message.kind !== 0) {
      writer.uint32(16).uint32(message.kind);
    }
    if (message.startTime !== "0") {
      writer.uint32(24).int64(message.startTime);
    }
    if (message.endTime !== "0") {
      writer.uint32(32).int64(message.endTime);
    }
    for (const v of message.originalVesting) {
      Coin.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.delegatedFree) {
      Coin.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.delegatedVesting) {
      Coin.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.periods) {
      Period.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VaultVestingSchedule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVaultVestingSchedule();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sourceAddress = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.startTime = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.endTime = reader.int64().toString();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.originalVesting.push(Coin.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.delegatedFree.push(Coin.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.delegatedVesting.push(Coin.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.periods.push(Period.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VaultVestingSchedule {
    return {
      sourceAddress: isSet(object.sourceAddress) ? bytesFromBase64(object.sourceAddress) : new Uint8Array(0),
      kind: isSet(object.kind) ? globalThis.Number(object.kind) : 0,
      startTime: isSet(object.startTime) ? globalThis.String(object.startTime) : "0",
      endTime: isSet(object.endTime) ? globalThis.String(object.endTime) : "0",
      originalVesting: globalThis.Array.isArray(object?.originalVesting)
        ? object.originalVesting.map((e: any) => Coin.fromJSON(e))
        : [],
      delegatedFree: globalThis.Array.isArray(object?.delegatedFree)
        ? object.delegatedFree.map((e: any) => Coin.fromJSON(e))
        : [],
      delegatedVesting: globalThis.Array.isArray(object?.delegatedVesting)
        ? object.delegatedVesting.map((e: any) => Coin.fromJSON(e))
        : [],
      periods: globalThis.Array.isArray(object?.periods) ? object.periods.map((e: any) => Period.fromJSON(e)) : [],
    };
  },

  toJSON(message: VaultVestingSchedule): unknown {
    const obj: any = {};
    if (message.sourceAddress.length !== 0) {
      obj.sourceAddress = base64FromBytes(message.sourceAddress);
    }
    if (message.kind !== 0) {
      obj.kind = Math.round(message.kind);
    }
    if (message.startTime !== "0") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "0") {
      obj.endTime = message.endTime;
    }
    if (message.originalVesting?.length) {
      obj.originalVesting = message.originalVesting.map((e) => Coin.toJSON(e));
    }
    if (message.delegatedFree?.length) {
      obj.delegatedFree = message.delegatedFree.map((e) => Coin.toJSON(e));
    }
    if (message.delegatedVesting?.length) {
      obj.delegatedVesting = message.delegatedVesting.map((e) => Coin.toJSON(e));
    }
    if (message.periods?.length) {
      obj.periods = message.periods.map((e) => Period.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VaultVestingSchedule>, I>>(base?: I): VaultVestingSchedule {
    return VaultVestingSchedule.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VaultVestingSchedule>, I>>(object: I): VaultVestingSchedule {
    const message = createBaseVaultVestingSchedule();
    message.sourceAddress = object.sourceAddress ?? new Uint8Array(0);
    message.kind = object.kind ?? 0;
    message.startTime = object.startTime ?? "0";
    message.endTime = object.endTime ?? "0";
    message.originalVesting = object.originalVesting?.map((e) => Coin.fromPartial(e)) || [];
    message.delegatedFree = object.delegatedFree?.map((e) => Coin.fromPartial(e)) || [];
    message.delegatedVesting = object.delegatedVesting?.map((e) => Coin.fromPartial(e)) || [];
    message.periods = object.periods?.map((e) => Period.fromPartial(e)) || [];
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
